import React from "react";
import * as Yup from "yup";
import CadastroPadrao from "../../../Components/Common/CadastroPadrao";

import {
  getTags,
  addNewTag,
  updateTag,
  deleteTag
} from "../../../slices/api/tag";

const Tags = () => {
  return (
  <CadastroPadrao
    titulo="Tags"
    labelSingular="Tag"
    reduxKey="tags"
    acoesRedux={{
      onGet: getTags,
      onAddNew: addNewTag,
      onUpdate: updateTag,
      onDelete: deleteTag,
    }}
    colunas={[
      { campo: "id", titulo: "Código" },
      { campo: "nome", titulo: "Nome" },
    ]}
    camposFormulario={[
      {
        nome: "nome",
        label: "Nome",
        placeholder: "Informe o nome da tag",
        validacao: Yup.string().required("Informe o nome da tag"),
      }
    ]}
  />
  );
};

export default Tags;